import styled from 'styled-components';


interface ContainerProps {
    isConnected: boolean;
}

export const Container = styled.div<ContainerProps>`
    background: ${(props) => (props.isConnected ? 'green' : 'grey')};
    width: 100%;
    height: 100%;
    border-style: solid;
    border-color: white;
    border-radius: 10px;
    border-width: 2px;
    &:hover {
        background: #1790FF;
    }
}
`;
